// extracted by mini-css-extract-plugin
export default {"genTitle":"Title_genTitle__GyOsn","genTitleWhite":"Title_genTitleWhite__qZAMR"};